import { SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Modal,
  Row,
  Select,
  Tabs,
} from "antd";
import { Store } from "antd/lib/form/interface";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  DefaultErrorMessage,
  Successfully,
  UpdateDataSuccessfully,
  NotificationText,
  Save,
  TimeZone,
} from "shared/constants/define-localization";
import { t, CoreResource } from "shared/plugins/localization";
import { setLoading } from "states/global-value/global-value.slice";
import {
  getSystemConfig,
  getTimeZones,
  updateSystemConfig,
} from "states/system-setting/system-setting.api";
import {
  LoginTypeTextList,
  SystemConfigModel,
  TimezoneModel,
} from "states/system-setting/system-setting.models";

export function SystemConfig() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [timeZoneList, setTimeZoneList] = useState<TimezoneModel[]>([]);

  const getConfig = async () => {
    try {
      const res = await getSystemConfig();
      form.setFieldsValue(res.data);
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
        "Lỗi hệ thống"
      );
    }
  };

  const onFinish = async (values: Store) => {
    dispatch(setLoading(true));
    try {
      let payload = {
        hostUrl: values.hostUrl,
        name: values.name,
        timeZone: values.timeZone,
        notificationEmails: values.notificationEmails,
        separateProductEachBranch: values.separateProductEachBranch,
        loginType: values.loginType,
      } as SystemConfigModel;
      await updateSystemConfig(payload);
      dispatch(setLoading(false));
      Modal.success({
        title: "Thành công",
        content: "Cập nhật thành công",
      });
    } catch (error) {
      dispatch(setLoading(false));
      Modal.error({
        title: "Thông báo",
        content:
          error?.response?.data?.error?.message ??
          "Lỗi hệ thống",
      });
    }
  };
  const onSaved = () => {
    form.submit();
  };
  useEffect(() => {
    getTimeZones().then((res) => {
      setTimeZoneList(res.data);
    });
    getConfig();
  }, []);

  return (
    <div className="website-config">
      <Tabs type="card">
        <Tabs.TabPane tab="Cấu hình hệ thống" key="he-thong">
          <Row gutter={[16, 16]} className="mb-4">
            <Col flex="auto"></Col>
            <Col flex="auto" className="d-flex justify-content-end">
              <Button onClick={onSaved} type="primary" icon={<SaveOutlined />}>
                {"Lưu"}
              </Button>
            </Col>
          </Row>
          <Row gutter={[16, 16]} justify="space-between">
            <Col span={24}>
              <Card title="Cấu hình hệ thống" bordered={false}>
                <Form
                  form={form}
                  name="website-config"
                  onFinish={onFinish}
                  layout="vertical"
                >
                  <Form.Item label="Tên hệ thống" name="name">
                    <Input placeholder="Tên hệ thống" />
                  </Form.Item>
                  <Form.Item label="Website Url" name="hostUrl">
                    <Input placeholder="Url (http://abc.com)" />
                  </Form.Item>
                  <Form.Item
                    label="Email nhận thông báo"
                    name="notificationEmails"
                  >
                    <Select mode="tags" placeholder="Email nhận thông báo" />
                  </Form.Item>
                  <Form.Item label="Time Zone" name="timeZone">
                    <Select
                      className="w-100"
                      placeholder={t(
                        CoreResource,
                        "SelectTheField",
                        t(CoreResource, TimeZone)
                      )}
                      allowClear
                      showSearch
                      filterOption={(input, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {timeZoneList &&
                        timeZoneList.map((t) => (
                          <Select.Option key={t.id} value={t.id}>
                            {t.displayName}
                          </Select.Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    valuePropName="checked"
                    name="separateProductEachBranch"
                  >
                    <Checkbox>Mỗi chi nhánh có sản phẩm khác nhau</Checkbox>
                  </Form.Item>
                  <Form.Item label="Kiểu đăng nhập" name="loginType">
                    <Select
                      className="w-100"
                      placeholder={"Kiểu đăng nhập"}
                      allowClear
                      showSearch
                      filterOption={(input, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {LoginTypeTextList.map((loginType) => (
                        <Select.Option key={loginType} value={loginType}>
                          {loginType}
                        </Select.Option>
                      ))}

                    </Select>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
          </Row>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}
